// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import util from './common/util.js'
import contract from './common/contractECO_V2.js'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUi from 'element-ui'
Vue.use(ElementUi);

/*
 从新部署项目说明:
 1. 在common/contractEco_v2.js 修改各个合约的地址和abi, 修改默认推荐人地址;
 */

// 同步锁 -- 这个项目是波场的ECO项目
Vue.prototype.$onLaunched = new Promise(resolve => {
  Vue.prototype.$isResolve = resolve
});

// 引入语言切换包
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
const i18n = new VueI18n({
  // 默认英文
  locale: localStorage.lang,
  messages: {
    EN: require('../static/lang/EN.json'),
    GER: require('../static/lang/GER.json'),
    IDN: require('../static/lang/IDN.json'),
    JP: require('../static/lang/JP.json'),
    KOR: require('../static/lang/KOR.json'),
    MYS: require('../static/lang/MYS.json'),
    VN: require('../static/lang/VN.json'),
    ZH: require('../static/lang/ZH.json'),
    HINDI:require('../static/lang/HINDI.json')
  }
});

// 全局的事件总线对象
Vue.prototype.$bus = new Vue();
Vue.prototype.$util = util;
Vue.prototype.$contract = contract;
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // 加入语言包
  i18n,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js